import { useSelector } from "react-redux";

const AdminProtectedRoute = ({ children }) => {
  const { isSeller } = useSelector((state) => state.seller);

  if (!isSeller) {
    return <div>Будь ласка увійдіть в систему</div>;
  }

  return children;
};


export default AdminProtectedRoute;
